import React, { useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const { naver } = window;
  let navigate = useNavigate();
  const { logout } = useAuth();
  useEffect(() => {
    const naverLogin = new naver.LoginWithNaverId({
      clientId: "KWVpgJ5ZYEOugfR6qcqt",
      callbackUrl: "https://prism-a6a80.firebaseapp.com/signup",
      isPopup: false, // popup 형식으로 띄울것인지 설정
      loginButton: { color: "white", type: 3, height: "47", width: "100%" }, //버튼의 스타일, 타입, 크기를 지정
    });
    console.log(naverLogin);
    naverLogin.init();
    naverLogin.logout();
  }, []);

  useEffect(() => {
    logout();
    navigate("/");
  }, []);

  return (
    <div>
      <div id="naverIdLogin" />
    </div>
  );
};

export default Logout;
